import { ButtonPrimary, Inline, SkeletonRectangle, skinVars, Stack, Text3, useScreenSize } from "@telefonica/mistica";
import React from "react";
import { strings } from "../../localization";
import { DataInfo } from "../DataInfo";
import { TextList } from "../TextList";
import { TextListItem } from "../TextListItem";
import { observer } from "mobx-react-lite";
import { formatAmount, formatMonthByNumber } from "../../utils/formatters";
import { colors } from "../../theme/colors";
import { Box, Text } from "@chakra-ui/react";

interface IProps {
	amountAvailable: number | string;
	FGTSBalance: number | string;
	birthMonth: number | string;
	isLoading?: boolean;
	action(): void;
}

export const ColdSimulationResults: React.FC<IProps> = observer((props) => {
	const { amountAvailable, FGTSBalance, birthMonth, action, isLoading } = props;
	const {
		components: { coldSimulationResults },
	} = strings;
	const { isMobile } = useScreenSize();

	const customStyle = {
		name: {
			fontFamily: "VivoType",
			fontSize: { base: "14px", lg: "16px" },
			lineHeight: { base: "20px", lg: "24px" },
			fontWeight: 600,
			color: colors.black[500],
		},
		description: {
			fontFamily: "VivoType",
			fontSize: { base: "14px", lg: "16px" },
			lineHeight: { base: "20px", lg: "24px" },
			fontWeight: 500,
			color: colors.gray[600],
		},
	};

	return (
		<DataInfo
			title={coldSimulationResults.title}
			titleStyle={{
				fontFamily: "VivoType",
				textAlign: { base: "left", lg: "center" },
				fontSize: { base: "20px", lg: "28px" },
				fontWeight: 500,
				lineHeight: { base: "24px", lg: "32px" },
				color: colors.black[500],
			}}
		>
			<Stack space={24}>
				<TextList>
					<Stack space={16}>
						<Inline alignItems="center" fullWidth space={0} className={"center-aligned"}>
							{isLoading ? (
								<SkeletonRectangle width={160} height={38} />
							) : (
								<Text
									color={skinVars.colors.promo}
									textAlign="center"
									fontFamily="VivoType"
									fontSize="32px"
									fontWeight="500"
									lineHeight="40px"
								>
									{formatAmount(+amountAvailable)}
								</Text>
							)}
						</Inline>
						<TextListItem
							name={coldSimulationResults.FGTSBalance}
							description={formatAmount(+FGTSBalance)}
							nameProps={customStyle.name}
							descripitionProps={customStyle.description}
						/>
						<TextListItem
							name={coldSimulationResults.birthMonth}
							description={formatMonthByNumber(+birthMonth)}
							nameProps={customStyle.name}
							descripitionProps={customStyle.description}
						/>
					</Stack>
				</TextList>
				<Box className="font-family-vivotype">
					<ButtonPrimary onPress={() => action()} style={{ width: isMobile ? "100%" : "203px", borderRadius: "999px" }}>
						<Text3 medium color={skinVars.colors.textButtonPrimary}>
							{coldSimulationResults.labelButton}
						</Text3>
					</ButtonPrimary>
				</Box>
			</Stack>
		</DataInfo>
	);
});
